import type { ValueCell } from "@okcontract/cells";
import { getContext } from "svelte";

export const ModalNoWallet = Symbol();

export const getNoWallet = () =>
  getContext(ModalNoWallet) as ValueCell<boolean>;
